"use client";

import { motion } from "framer-motion";
import {
  GraduationCap,
  Palette,
  Users,
  HeartHandshake,
  Sparkles,
  Crown,
  UtensilsCrossed,
  Flag,
  Star,
} from "lucide-react";

const values = [
  {
    icon: GraduationCap,
    title: "Le plus savant",
    text: "La science agronomique au service du goût.",
  },
  {
    icon: Palette,
    title: "Le plus joli",
    text: "Des couleurs, des formes, des presentations soignées.",
  },
  {
    icon: Users,
    title: "Le plus animé",
    text: "Un marché vivant, des échanges, une communauté.",
  },
  {
    icon: HeartHandshake,
    title: "Le plus ouvert",
    text: "Accessible à tous, du particulier au restaurateur.",
  },
  {
    icon: Sparkles,
    title: "Le plus attirant",
    text: "Des produits qui donnent envie, qui invitent au festin.",
  },
  {
    icon: Crown,
    title: "Le plus élégant",
    text: "Du champ à l'assiette, une exigence de présentation.",
  },
  {
    icon: UtensilsCrossed,
    title: "Le plus nourricier",
    text: "Fibres, vitamines, énergie — la racine qui nourrit.",
  },
  {
    icon: Flag,
    title: "Le plus patriote",
    text: "Souveraineté alimentaire et fierté nationale.",
  },
  {
    icon: Star,
    title: "Le plus émerveillant",
    text: "Chaque commande est une promesse d'émerveillement.",
  },
];

export function Values() {
  return (
    <section id="valeurs" className="relative py-24 lg:py-32 bg-gradient-to-b from-secondary/40 to-background">
      <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="max-w-3xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="divider-gold max-w-xs mx-auto mb-5"
          >
            <span className="text-xs uppercase tracking-[0.32em] text-gold-deep font-semibold">
              Nos Valeurs
            </span>
          </motion.div>

          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.05 }}
            className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight"
          >
            Neuf promesses, une{" "}
            <span className="text-gradient-gold">maison</span>
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.15 }}
            className="mt-6 text-base sm:text-lg text-muted-foreground leading-relaxed"
          >
            PATATE OR se définit par neuf engagements, nine qualités, neuf promesses.
            Chacune est une facette de notre identité, chacune guide chacune de nos
            décisions, du choix de la semence à la livraison chez vous.
          </motion.p>
        </div>

        {/* Values grid */}
        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {values.map((v, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, scale: 0.92 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
              className="group relative p-6 rounded-2xl bg-card border border-border hover:border-gold transition-all duration-500 hover:shadow-gold hover:-translate-y-1"
            >
              <div className="flex items-start gap-4">
                <div className="shrink-0 grid place-items-center w-12 h-12 rounded-xl bg-secondary group-hover:bg-gradient-gold transition-colors">
                  <v.icon className="w-6 h-6 text-gold-deep group-hover:text-white transition-colors" strokeWidth={1.8} />
                </div>
                <div className="flex-1">
                  <h3 className="font-display text-lg font-bold text-foreground">
                    {v.title}
                  </h3>
                  <p className="mt-1 text-sm text-muted-foreground leading-relaxed">
                    {v.text}
                  </p>
                </div>
              </div>

              <div className="absolute top-3 right-3 text-7xl font-display font-black text-gold/5 group-hover:text-gold/10 transition-colors">
                {String(i + 1).padStart(2, "0")}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
